// eslint-disable-next-line no-restricted-imports
import {
  LegalClientLegalHeadFirstHeadForLegalClientLegalHeadFragment,
  Query_LegalClientController_GetList_AllOf_1_List_Items_LegalHeads_Items_FirstHeads_Items_Status,
} from 'api/generated/graphql';
import { parseCountryEntity } from 'api/helpers/parseCountryEntity';
import { LegalClientInnerItemEntity } from 'api/types/entity/legal/legalClientInnerItemEntity';

export const parseLegalClientFirstHeadItemEntity = (
  data: LegalClientLegalHeadFirstHeadForLegalClientLegalHeadFragment
): LegalClientInnerItemEntity => ({
  id: data.id,
  name: `${data.lastName} ${data.firstName} ${data.middleName ?? ''}`,
  registrationCountry: data.registrationAddress
    ? parseCountryEntity(data.registrationAddress.country)
    : undefined,
  residentialCountry: data.residentialAddress
    ? parseCountryEntity(data.residentialAddress.country)
    : undefined,
  email: data.email,
  createdAt: new Date(data.createdAt),

  archived:
    data.status ===
    Query_LegalClientController_GetList_AllOf_1_List_Items_LegalHeads_Items_FirstHeads_Items_Status.Archived,

  positionInCompany: data.positionInCompany
    ? {
        expirationDate: data.positionInCompany.expirationDate
          ? new Date(data.positionInCompany.expirationDate)
          : undefined,
        position: data.positionInCompany.positionInCompany,
      }
    : undefined,
});
